import { createContext } from 'react';
import type { Scheme, Theme } from '@/styles/tokens';

export interface ThemeContextValue {
  /** Brand palette: the design system ships g90, purple, sky and amber. */
  scheme: Scheme;
  /** Light or dark variant of the active scheme. */
  theme: Theme;
  setScheme: (scheme: Scheme) => void;
  setTheme: (theme: Theme) => void;
  toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);
